module.exports = __webpack_public_path__ + "img/Frame1.9df647a7.png";